define.alias("shared/modifiers/scroll-to-bottom", "settings/modifiers/scroll-to-bottom");